import { render } from "./developers.vue?vue&type=template&id=82acfb12"
import script from "./developers.vue?vue&type=script&lang=js"
export * from "./developers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__